export const FULL_MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const SHORT_MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const FULL_WEEK_DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
export const MILLISECONDS_TO_YEAR = 31536000000;

// Date format regex patterns
export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const DD_MM_YYYY_REGEX = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

/**
 * Fallback map of IANA timezone identifiers to their common abbreviations.
 * Used when Intl.DateTimeFormat returns a numeric offset (e.g., "GMT+4") instead of
 * a named abbreviation. If a timezone is not in this map, the timezone identifier
 * itself is displayed as the fallback.
 */
export const TIMEZONE_ABBREVIATIONS: Record<string, string> = {
  // Gulf / Middle East
  'Asia/Dubai': 'UAE Standard Time',
  'Asia/Riyadh': 'AST',
  'Asia/Kuwait': 'AST',
  'Asia/Qatar': 'AST',
  'Asia/Bahrain': 'AST',
  'Asia/Muscat': 'GST',
  'Asia/Baghdad': 'AST',
  'Asia/Amman': 'AST',
  'Asia/Beirut': 'EET',
  'Asia/Damascus': 'EET',
  'Asia/Gaza': 'EET',
  'Asia/Jerusalem': 'IST',
  'Asia/Aden': 'AST',

  // South Asia
  'Asia/Kolkata': 'IST',
  'Asia/Karachi': 'PKT',
  'Asia/Dhaka': 'BST',
  'Asia/Colombo': 'IST',
  'Asia/Kathmandu': 'NPT',
  'Asia/Kabul': 'AFT',
  'Asia/Thimphu': 'BTT',
  'Indian/Maldives': 'MVT',

  // Southeast Asia
  'Asia/Manila': 'PHT',
  'Asia/Jakarta': 'WIB',
  'Asia/Kuala_Lumpur': 'MYT',
  'Asia/Singapore': 'SGT',
  'Asia/Bangkok': 'ICT',
  'Asia/Ho_Chi_Minh': 'ICT',
  'Asia/Yangon': 'MMT',

  // East Asia
  'Asia/Shanghai': 'CST',
  'Asia/Tokyo': 'JST',
  'Asia/Seoul': 'KST',
  'Asia/Taipei': 'CST',
  'Asia/Hong_Kong': 'HKT',

  // Central Asia
  'Asia/Almaty': 'ALMT',
  'Asia/Tashkent': 'UZT',

  // Europe
  'Europe/London': 'GMT',
  'Europe/Berlin': 'CET',
  'Europe/Paris': 'CET',
  'Europe/Rome': 'CET',
  'Europe/Madrid': 'CET',
  'Europe/Lisbon': 'WET',
  'Europe/Amsterdam': 'CET',
  'Europe/Brussels': 'CET',
  'Europe/Zurich': 'CET',
  'Europe/Vienna': 'CET',
  'Europe/Warsaw': 'CET',
  'Europe/Prague': 'CET',
  'Europe/Budapest': 'CET',
  'Europe/Bucharest': 'EET',
  'Europe/Athens': 'EET',
  'Europe/Istanbul': 'TRT',
  'Europe/Moscow': 'MSK',
  'Europe/Helsinki': 'EET',
  'Europe/Stockholm': 'CET',
  'Europe/Oslo': 'CET',
  'Europe/Copenhagen': 'CET',
  'Europe/Dublin': 'GMT',

  // Americas
  'America/New_York': 'EST',
  'America/Chicago': 'CST',
  'America/Denver': 'MST',
  'America/Los_Angeles': 'PST',
  'America/Toronto': 'EST',
  'America/Vancouver': 'PST',
  'America/Mexico_City': 'CST',
  'America/Sao_Paulo': 'BRT',
  'America/Argentina/Buenos_Aires': 'ART',
  'America/Bogota': 'COT',
  'America/Lima': 'PET',
  'America/Santiago': 'CLT',

  // Africa
  'Africa/Cairo': 'EET',
  'Africa/Johannesburg': 'SAST',
  'Africa/Lagos': 'WAT',
  'Africa/Nairobi': 'EAT',
  'Africa/Casablanca': 'WET',

  // Oceania
  'Australia/Sydney': 'AEST',
  'Pacific/Auckland': 'NZST',
  'Australia/Perth': 'AWST'
};
